import { useEffect } from "react";

/**
 * useDocumentMeta — sets <title> and <meta name="description"> imperatively
 * (no react-helmet dependency). Reverts on unmount.
 */
export function useDocumentMeta({ title, description } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    let descTag = document.querySelector('meta[name="description"]');
    const prevDesc = descTag ? descTag.getAttribute("content") : null;
    if (description) {
      if (!descTag) {
        descTag = document.createElement("meta");
        descTag.setAttribute("name", "description");
        document.head.appendChild(descTag);
      }
      descTag.setAttribute("content", description);
    }

    return () => {
      document.title = prevTitle;
      if (descTag && prevDesc !== null) descTag.setAttribute("content", prevDesc);
    };
  }, [title, description]);
}

export default useDocumentMeta;
